<template>
  <v-card>
    <v-card-title class="headline font-weight-thin">Confirm Your Changes</v-card-title>
    <v-card-text>
      Are you sure you want to make the following changes?
    </v-card-text>
    <v-card-text>
      <div>
        <div class="font-weight-bold">
          Applications that DO impact your organization:
        </div>
        <div class="mb-3">
          <span data-cy="applicationsImpactingOrganization">
            {{ applicationsImpactingOrganization || "None" }}
          </span>
        </div>
      </div>
      <div>
        <div class="font-weight-bold mt-3">
          Applications that DO NOT impact your organization:
        </div>
        <div class="mb-3">
          <span data-cy="excludedApplicationList">
            {{ excludedApplicationList || "None" }}
          </span>
        </div>
      </div></v-card-text
    >
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" outlined>Cancel</v-btn>
      <v-btn
        class="elevation-0 font-weight-bold"
        color="primary"
        data-cy="confirmApplicationAdmin"
        @click="submit"
        outlined
        >Submit</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  computed: {
    applicationsImpactingOrganization() {
      const clonedDropdownList = cloneDeep(this.dropdownList);
      const filteredDropdownList = clonedDropdownList.filter(({ id }) => !this.changes.newVal.includes(id));
      return filteredDropdownList
        .map(({ label }) => label)
        .sort()
        .join(", ");
    },
    excludedApplicationList() {
      return this.changes.newVal
        .map(id => this.formatValue(id))
        .sort()
        .join(", ");
    },
  },
  methods: {
    cancel() {
      this.$emit("setConfirmationDialog", false);
    },
    formatValue(val) {
      const app = this.dropdownMap[val];
      return app.label;
    },
    submit() {
      this.$emit("saveConfig");
      this.$emit("setConfirmationDialog", false);

      this.$router.push({
        name: "adminOrganizationSettings",
      });
    },
  },
  props: {
    dropdownMap: { required: true, type: Object },
    dropdownList: { required: true, type: Array },
    changes: { required: true, type: Object },
  },
};
</script>
